module.exports = __webpack_public_path__ + "../resources/images/illustration_folder-e35afbda8d7ea057b7153a04b50e14cc.svg";